import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
	apiKey: "AIzaSyDqJBcPihtryD6PN3_PT32puTKOhTWAr0s",
	authDomain: "baton-8a6b5.firebaseapp.com",
	projectId: "baton-8a6b5",
	storageBucket: "baton-8a6b5.appspot.com",
	messagingSenderId: "19423004526",
	appId: "1:19423004526:web:6685ca8761823608f3637f",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

export { db, auth, functions };
